import {
  LeftCircleFilled,
  LeftCircleOutlined,
  LeftOutlined,
  RightCircleOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { Carousel, Col, Empty, Image, Row, Skeleton, Spin, Tooltip } from 'antd';
import { useEffect, useReducer, useRef, useState } from 'react';
import ImageCarousel from './ImageCarousel';

const LinkList = (props) => {
  const [links, setLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const carouselRef = useRef(null);

  useEffect(() => {
    asyncFetch();
  }, [props.usePublico]);

  const asyncFetch = () => {
    setIsLoading(true);
    setLinks([]);
    let fetchUrl = `https://arquivo.pt/textsearch?q=${props.label}&prettyPrint=true&dedupValue=1&dedupField=site`;
    if (props.usePublico) fetchUrl += `&siteSearch=http://www.publico.pt`;

    fetch(fetchUrl)
      .then((response) => response.json())
      .then((json) => {
        setLinks(
          json.response_items.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index / 5);

            if (!resultArray[chunkIndex]) {
              resultArray[chunkIndex] = [];
            }

            resultArray[chunkIndex].push(item);
            return resultArray;
          }, [])
        );
        setIsLoading(false);
      })
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  const handleLeftArrow = () => {
    carouselRef.current.prev();
  };

  const handleRightArrow = () => {
    carouselRef.current.next();
  };

  return (
    <>
      {isLoading && <Spin />}
      {!isLoading && links.length === 0 && <Empty />}

      {!isLoading && links.length > 0 && <ImageCarousel images={links} />}
    </>
  );
};

export default LinkList;
